<template>
  <div class="general-reporting">
    <div class="workload-data">
      <div class="workload-list mt-4 mx-3 pt-4">

        <material-card
          color="orange"
          title="Search Registration Reports">
          <div
            v-show="!workloadView"
            class="workload-list">

            <v-expansion-panel>
              <v-expansion-panel-content>
                <template v-slot:header>
                  <div>Filter Search</div>
                </template>

                <v-layout row justify-xl-start class="search-box">
                  <v-flex md3 mx-3>
                    <v-menu
                      v-model="fromDateModal"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="from_date"
                          label="Start Date"
                          prepend-icon="event"
                          clearable
                          readonly
                          v-on="on"
                        />
                      </template>
                      <v-date-picker
                        :max="new Date().toISOString().substr(0, 10)"
                        v-model="from_date"
                        @input="fromDateModal = false"/>
                    </v-menu>
                  </v-flex>

                  <v-flex md3>
                    <v-menu
                      v-model="endDateModal"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="end_date"
                          label="End Date"
                          prepend-icon="event"
                          clearable
                          readonly
                          v-on="on"/>
                      </template>
                      <v-date-picker
                        :max="new Date().toISOString().substr(0, 10)"
                        v-model="end_date"
                        @input="endDateModal = false"
                        @change="onDateFilterUpdate"/>
                    </v-menu>
                  </v-flex>

                  <v-spacer />

                  <v-flex md5>
                    <v-btn
                      :loading="newOppRegistration.searching"
                      color="success"
                      @click="filterOppRegRequestData">Search
                    </v-btn>

                    <!-- <v-btn
                      :loading="newOppRegistration.inProgress"
                      color="success"
                      @click="downloadAWSextracData">Download
                    </v-btn> -->

                    <v-btn
                      :disabled="!canReport"
                      :loading="newOppRegistration.reportInProgress"
                      color="success"
                      @click="extractAWSReportData">Report
                    </v-btn>
                  </v-flex>

                </v-layout>

                <v-layout row justify-sm-start class="search-box">

                  <v-flex md3 mx-3>
                    <label>DXC SFDC Opportunity ID:</label>
                    <v-text-field
                      v-model.trim="sfdcId"
                      solo
                      placeholder="DXC SFDC OPPORTUNITY ID"/>
                    <label>Customer Name:</label>
                    <v-text-field
                      v-model.trim="Customer_Name"
                      solo
                      placeholder="CUSTOMER NAME"/>
                    <label>AWS ACE ID:</label>
                    <v-text-field
                      v-model.trim="AWS_ACE_ID"
                      solo
                      placeholder="AWS ACE ID"/>
                  </v-flex>

                  <v-flex md2 mx-3>
                    <h4>Choose Region</h4>
                    <div
                      v-for="region in filteredRegions"
                      :key="region">
                      <v-checkbox
                        v-model="selectedESRegion"
                        :disabled="includesRegion(region)"
                        :label="region"
                        :value="region"
                        hide-details
                        multiple
                        color="orange"
                        @change="onSelectESRegion"
                      />
                    </div>

                  </v-flex>
                  <v-flex md2 mx-3>
                    <h4>Choose Initiative</h4>
                    <!-- <v-container fluid> -->
                      <v-checkbox
                        v-model="selectedGlacierInitiative"
                        hide-details
                        color="orange"
                        label="Glacier Campaign"
                        value="Glacier"
                      />
                      <v-checkbox
                        v-model="selectedGlobalInitiative"
                        hide-details
                        color="orange"
                        label="Global Register Initiative"
                        value="Global"
                      />
                    <!-- </v-container> -->
                  </v-flex>

                  <v-flex
                    xs13
                    sm4
                    md4
                    xl3
                    mx-3>
                    <h4>Choose Status</h4>
                    <v-select
                      v-model="selectedStatus"
                      :items="NewWorkloadStatus"
                      label="Filter by Status"
                      multiple
                      chips
                      solo
                      attach
                      @change="changedStatus"/>
                    <h4>Requestor Email:</h4>
                    <v-text-field
                      v-model.trim="RequestorEmail"
                      solo
                      placeholder="Requestor Email"/>
                  </v-flex>
                  <!-- <v-flex md3>
                    <h4>Choose Status</h4>
                    <v-radio-group v-model="Workload_Status">
                      <template v-for="item in filteredWorkBookStatus">
                        <v-radio
                          :label="item"
                          :value="item"
                          color="orange"/>
                      </template>
                    </v-radio-group>
                  </v-flex> -->

                  

                  <!-- <v-flex md3>
                    <h4>Choose Form</h4>
                    <v-radio-group v-model="ViewType">
                      <template v-for="item in filteredViewTypeList">
                        <v-radio
                          :label="item"
                          :value="item"
                          color="orange"/>
                      </template>
                    </v-radio-group>
                  </v-flex> -->
               
                </v-layout>

              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-divider/>

            <!-- <v-progress-linear
              v-slot:progress
              v-if="loadingRequest"
              color="orange"
              indeterminate/> -->

            <v-data-table
              :headers="filteredWorkloadHeaders"
              :items="adminReportWorkloadList"
              :pagination.sync="pagination"
              :loading="newOppRegistration.searching"
              :class="{ 'no-select': hasRegionFilter() }"
              item-key="Project_Id"
              disable-initial-sort
              hide-actions
              @contextmenu.prevent
            >
              <template v-slot:no-data>
                <v-alert
                  v-if="newOppRegistration.withError"
                  :value="true"
                  color="#000"
                  icon="warning">
                  No Opportunity Registration request found! Please check Filters and try again.
                </v-alert>
              </template>
              <template
                slot="headerCell"
                slot-scope="{ header }">
                <span
                  class="subheading font-weight-light text-success text-md-left text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template v-slot:items="props">
                <tr v-if="ViewType === 'Default'">
                  <td>
                    <Can
                      i="manage"
                      a="oppreg">
                      <a
                        href="#"
                        @click="onWorkloadView(props.item)">{{ props.item.Project_Id }}</a>
                    </Can>
                  </td>
                  <td>{{ props.item.OppReg_Id }}</td>
                  <td>{{ props.item.AWS_ACE_ID }}</td>
                  <!-- <td>{{ props.item.Opportunity_Number }}</td> -->
                  <td>
                    <a
                      href="#"
                      @click="onWorkloadView(props.item)">{{ props.item.SFDC_Oppty_Name }}</a>
                  </td>
                  <td>{{ props.item.Workload_Title }}</td>
                  <td>{{ props.item.Workload_Status }}</td>
                  <td>{{ props.item.Workload_type }}</td>
                  <td>{{ props.item.Campaign_Name }}</td>
                  <td>{{ props.item.Requestor_Email }}</td>
                  <td>{{ props.item.Customer_Name }}</td>
                  <td>{{ props.item.Customer_Region }}</td>
                  <td>{{ props.item.Country }}</td>
                  <td>{{ props.item.SignDate }}</td>
                  <td>{{ props.item.Q4 }}</td>
                  <td>{{ props.item.Q5 }}</td>
                  <td>{{ props.item.Q6 }}</td>
                  <td>{{ props.item.Attested_By_Email }}</td>
                  <td>{{ props.item.Date_Created }}</td>
                </tr>

                <!-- SIMPLE -->
                <tr v-if="ViewType === 'Simple'">
                  <td>
                    <Can
                      i="manage"
                      a="oppreg">
                      <a
                        href="#"
                        @click="onWorkloadView(props.item)">{{ props.item.Project_Id }}</a>
                    </Can>
                  </td>
                  <td>{{ props.item.OppReg_Id }}</td>
                  <td>{{ props.item.AWS_ACE_ID }}</td>
                  <!-- <td>{{ props.item.Opportunity_Number }}</td> -->
                  <td>{{ props.item.Customer_Name }}</td>
                  <td>{{ props.item.Customer_Region }}</td>
                  <td>
                    <Can
                      i="manage"
                      a="oppreg">
                      <a
                        href="#"
                        @click="onWorkloadView(props.item)">{{ props.item.SFDC_Oppty_Name }}</a>
                    </Can>
                  </td>
                  <td>{{ props.item.Workload_Title }}</td>
                  <td>{{ props.item.Workload_Status }}</td>
                  <td>{{ props.item.Workload_type }}</td>
                  <td>{{ props.item.Campaign_Name }}</td>
                  <td>{{ props.item.Requestor_Email }}</td>
                  <td>{{ props.item.SignDate }}</td>
                  <td>{{ props.item.Q5 }}</td>
                  <td>{{ props.item.Q6 }}</td>
                  <td>{{ props.item.Attested_By_Email }}</td>
                  <td>{{ props.item.Date_Created }}</td>
                </tr>

                <!-- EXPANDED -->
                <tr v-if="ViewType === 'Expanded'">
                  <td>
                    <Can
                      i="manage"
                      a="oppreg">
                      <a
                        href="#"
                        @click="onWorkloadView(props.item)">{{ props.item.Project_Id }}</a>
                    </Can>
                  </td>
                  <td>{{ props.item.OppReg_Id }}</td>
                  <td>{{ props.item.AWS_ACE_ID }}</td>
                  <!-- <td>{{ props.item.Opportunity_Number }}</td> -->
                  <td>{{ props.item.Customer_Name }}</td>
                  <td>{{ props.item.Workload_Title }}</td>
                  <td>{{ props.item.Customer_Region }}</td>
                  <td>{{ props.item.SignDate }}</td>
                  <td>
                    <Can
                      i="manage"
                      a="oppreg">
                      <a
                        href="#"
                        @click="onWorkloadView(props.item)">{{ props.item.SFDC_Oppty_Name }}</a>
                    </Can>
                  </td>
                  <td>{{ props.item.Q4 }}</td>
                  <td>{{ props.item.Workload_Status }}</td>
                  <td>{{ props.item.Workload_type }}</td>
                  <td>{{ props.item.Campaign_Name }}</td>
                  <td>{{ props.item.Requestor_Email }}</td>
                  <td>{{ props.item.Q5 }}</td>
                  <td>{{ props.item.Q6 }}</td>
                  <td>{{ props.item.Attested_By_Email }}</td>
                  <td>{{ props.item.Date_Created }}</td>
                </tr>
              </template>
            </v-data-table>
            <v-progress-linear
              v-slot:progress
              v-if="loadingRequest"
              color="orange"
              indeterminate/>
            <div class="text-xs-center mt-3" >
              <v-btn :disabled="!adminReportNextPageKey" small @click="showNextData">LOAD MORE...</v-btn>
            </div>
          </div>

          <div
            v-show="workloadView"
            class="workload-detail-view">
            <v-layout row>
              <v-flex>
                <v-btn @click="workloadView = false">Go back to list</v-btn>
              </v-flex>
              <v-flex style="text-align: right">
                <v-btn @click="showChangelogs(workloadData)"><v-icon
                  small
                  title="Changelogs"
                  class="mr-2"
                  color="primary"
                  flat>history</v-icon>View Changelogs</v-btn>
              </v-flex>
            </v-layout>
            <table>
              <tr>
                <th>Field</th>
                <th>Value</th>
              </tr>
              <tr v-for="(value, name) in workloadViewData">
                <td>{{ name }}</td>
                <td>{{ value }}</td>
              </tr>
            </table>
          </div>

        </material-card>
      </div>
    </div>
  </div>
</template>
<script>

import { mapMutations, mapState, mapActions } from 'vuex'
import { getAwsExtractData, getAwsReportData } from '@/utils/helper'
import { Ability, subject } from '@casl/ability';

const ability = new Ability();

export default {
  $_veeValidate: { validator: 'new' },
  data () {
    return {
      from_date: '',
      end_date: '',
      fromDateModal: false,
      endDateModal: false,
      onDateFilterUpdate: false,
      sfdcId: '',
      Customer_Name: '',
      AWS_ACE_ID: '',
      ESRegion: '',
      selectedESRegion: [],
      selectedGlacierInitiative: '',
      selectedGlobalInitiative: '',
      Workload_Status: '',
      ViewType: 'Default',
      regions: ['Americas', 'UKI', 'Europe', 'APJ-MEA'],
      initiatives: ['Glacier Campaign', 'Global Register Initiative'],
      // WorkBookStatus: ['All', 'Incomplete', 'Submitted by User', 'Ready for submission'],
      viewTypeList: ['Default', 'Simple', 'Expanded'],
      pagination: {
        descending: true,
        sortBy: 'Date_Created',
        page: 1,
        rowsPerPage: 10,
        totalItems: 0,
        size: 10
      },
      workloadView: false,
      workloadData: {},
      workloadFields: [
        'Registration_Id',
        'SFDC_Id',
        'SignDate',
        'Oppreg_Req_Date',
        'Workload_Status',
        'SFDC_Oppty_Name',
        'Customer_Name',
        'Customer_Region',
        'Customer_Address',
        'Customer_City',
        'Customer_State',
        'Customer_PC',
        'Customer_URL',
        'Contact_FullName',
        'Contact_Phone',
        'RFI_RFP',
        'Workload_Title',
        'Workload_type',
        'WL_Q1A',
        'WL_Q2A',
        'WL_Q3A',
        'WL_Q4A',
        'WL_Q5A',
        'WL_Q6A',
        'Attested_By',
        'DXC_Services',
        'WL_Q7A',
        'WL_Q8A',
        'WL_Q9A',
        'WL_Q10A',
        'Projected_Monthly_Spend',
        'Scope_of_Work'
      ],
      NewWorkloadStatus: [
        'All',
        'AWS Reg Accepted',
        'Disqualified - AWS forecast conflict',
        'Disqualified - Duplicate',
        'Disqualified - Duplicate Tier 3 12%',
        'Disqualified - Forecast Conflict',
        'Disqualified - Forecast Conflict Tier 3 12%',
        'Disqualified - Incomplete',
        'Disqualified - No AWS scope',
        'Disqualified - Shareshift',
        'DXC Won',
        'Incomplete/Under Review',
        'In Review',
        'LEGACY - Approved - Tier 1 23% - PPA',
        'LEGACY - Approved - Tier 1 23% - PPA SaaS',
        'LEGACY - Approved - Tier 2 - Custom EDP',
        'LEGACY - Approved - Tier 3 12%',
        'LEGACY - Internal - Tier 1 23% - PPA',
        'On hold – No Product in SF yet',
        'OppReg Closed',
        'Shareshift',
        'Submitted by User',
        'Submitted to AWS'
      ],
      selectedStatus: null,
      RequestorEmail: ''
    }
  },
  mounted () {
    this.$store.dispatch('admin/oppregAdmin/clearAdminReportWorkloadList')
    this.$store.dispatch('admin/oppregAdmin/getOppRegRequestData', { size: this.pagination.size })
  },
  computed: {
    workloadViewData () {
      let viewData = {}
      if (Object.entries(this.workloadData).length !== 0) {
        for (var key in this.workloadData) {
          if (this.workloadFields.includes(key)) {
            viewData[key] = this.workloadData[key]
          }
        }
      }
      return viewData
    },
    ...mapState('admin/oppregAdmin', ['OppRegMasterHeaders', 'OppRegRequestHeaders', 'OppRegExpandedHeaders', 'workloadList','workloadLists1', 'newOppRegistration', 'loadingRequest', 'adminReportNextPageKey','adminReportWorkloadList']),
    filteredWorkloadHeaders () {
      let simpleHeader = ['Project_Id', 'OppReg_Id', 'AWS_ACE_ID', 'Customer_Name', 'SFDC_Oppty_Name', 'Workload_Title', 'Workload_Status', 'Workload_type', 'Campaign_Name', 'Requestor_Email', 'Customer_Region', 'SignDate', 'Public_Sector', 'Advisory_Services', 'Attestation', 'Date_Created']
      let expandedHeader = ['Project_Id', 'OppReg_Id', 'AWS_ACE_ID', 'Customer_Name', 'Workload_Title', 'Customer_Region', 'SignDate', 'SFDC_Oppty_Name', 'Projected_Monthly_Spend','Scope_of_Work', 'Workload_Status', 'Workload_type', 'Campaign_Name', 'Requestor_Email','Public_Sector', 'Advisory_Services', 'Attestation', 'Date_Created']
      let defaultHeader = ['Project_Id', 'OppReg_Id', 'AWS_ACE_ID', 'SFDC_Oppty_Name', 'Workload_Title', 'Workload_Status', 'Workload_type',  'Campaign_Name', 'Requestor_Email', 'Customer_Name', 'Customer_Region', 'Country', 'Closing_Date', 'AWS_Est_Rev', 'Public_Sector', 'Advisory_Services', 'Attestation', 'Date_Created']
      
      if (this.ViewType === 'Simple') {
        return this.OppRegRequestHeaders.filter(header => simpleHeader.includes(header.value))
      } else if (this.ViewType === 'Expanded') {
        return this.OppRegExpandedHeaders.filter(header => expandedHeader.includes(header.value))
      } else if (this.ViewType === 'Default') {
        return this.OppRegMasterHeaders.filter(header => defaultHeader.includes(header.value))
      }
    },
    filteredRegions () {
      return this.regions
    },
    filteredWorkBookStatus () {
      return this.WorkBookStatus
    },
    filteredViewTypeList () {
      return this.viewTypeList
    },
    filteredWorkloadList () {
      return this.workloadList
    },
    filteredWorkloadList () {
      return this.workloadList1
    },
    awsExtractData () {
      if (this.workloadList.length) {
        console.log('------ this.workloadList -------')
        console.log(this.workloadList)
        console.log('--------------------------------')
        return getAwsExtractData(this.workloadList)
      }
    },
    awsReportData () {
      if (this.workloadLists1.length) {
        console.log('------ mytest -------')
        console.log(this.workloadLists1)
        console.log('--------------------------------')
        return getAwsReportData(this.workloadLists1)
      }
    },
    canReport () {
      
      const hasReportPermission = this.$ability.can('report', 'oppreg')

      if (!hasReportPermission) return false

      const hasRegionFilter = this.$ability.rules.some(rule => rule.actions === 'report-filter-regions');

      if (hasRegionFilter) {
        // Track whether a message has been shown
        let messageShown = false

        if (Array.isArray(this.selectedESRegion)) {
          const unauthorizedRegion = this.selectedESRegion.find(region =>
            !this.$ability.can('report-filter-regions', region)
          )

          if (unauthorizedRegion && !messageShown) {
            alert(`You are not part of ${unauthorizedRegion}, so you cannot generate a report.`);
            messageShown = true // Ensure the alert appears only once
            return false
          }

          return true
        }

        if (!this.$ability.can('report-filter-regions', this.selectedESRegion) && !messageShown) {
          alert(`You are not part of ${this.selectedESRegion}, so you cannot generate a report.`)
          messageShown = true
          return false
        }

        return true
      } else {
        return true
      }
    }
  },
  methods: {
    ...mapMutations({
      clearWorkloadForm: 'admin/oppregAdmin/clearWorkloadForm',
      showNewWorkload: 'admin/oppregAdmin/showNewWorkload',
      setWorkloadData: 'admin/oppregAdmin/setWorkloadData',
      showEditWorkload: 'admin/oppregAdmin/showEditWorkload',
      hideWorkload: 'admin/oppregAdmin/hideWorkload',
      resetNewOppRegistration: 'admin/oppregAdmin/resetNewOppRegistration',
      setValidatedRegistration: 'admin/oppregAdmin/setRegistrationIdValidation',
      setOpportunityFound: 'admin/oppregAdmin/setOpportunityFound',
      delWorkloadFields: 'admin/oppregAdmin/delWorkloadFields',
      resetAdminReportWorkloadList: 'admin/oppregAdmin/resetAdminReportWorkloadList'

    }),
    getReportFilters (reportAction) {
      const selectedStatus = this.selectedStatus && !this.selectedStatus.includes('All') ? this.selectedStatus.toString() : '';
      let filters = {
        action: reportAction
      }
      if (this.sfdcId) {
        filters['sfdcId'] = this.sfdcId
      }
      if (this.Customer_Name) {
        filters['Customer_Name'] = this.Customer_Name
      }
      if (this.Workload_Status) {
        filters['Workload_Status'] = selectedStatus
      }
      if (this.from_date) {
        filters['from_date'] = this.from_date
      }
      if (this.end_date) {
        filters['to_date'] = this.end_date
      }
      if (this.selectedESRegion && this.selectedESRegion.length) {
        const excludeArray = ['All Region', 'All']
        filters['ESRegion'] = this.selectedESRegion.filter(item => !excludeArray.includes(item)).toString()
      }
      if (this.selectedGlobalInitiative) {
        filters['Global_Registered'] = 'Yes'
      }
      if (this.selectedGlacierInitiative) {
        filters['Campaign_Name'] = 'Glacier'
      }
      if (this.AWS_ACE_ID) {
        filters['AWS_ACE_ID'] = this.AWS_ACE_ID
      }
      if (this.RequestorEmail) {
        filters['Requestor_Email'] = this.RequestorEmail
      }
      const groups = vm.$store.state.currentUser.groups
      console.log('groups', groups)
      if (['GalaxyAdmin-Americas', 'GalaxyAdmin-Europe', 'GalaxyAdmin-APJ-MEA'].some(g => groups.includes(g))) {
        filters['report_type'] = 'regional'
      }
      console.log('getReportFilters', filters)
      return filters
    },
    onSearchOpportunity () {
      this.$store.dispatch('admin/oppregAdmin/getWorkloadsByOppId', this.searchId)
    },
    onWorkloadView (data) {
      this.workloadView = true
      this.workloadData = data
    },
    filterOppRegRequestData () {
      this.resetAdminReportWorkloadList()
      const selectedStatus = this.selectedStatus && !this.selectedStatus.includes('All') ? this.selectedStatus.toString() : '';
      console.log('selectedStatus>>>',selectedStatus)
      let params = {
        size: this.pagination.size
      }
      if (this.sfdcId) {
        params['sfdcId'] = this.sfdcId
      }
      if (this.Customer_Name) {
        params['Customer_Name'] = this.Customer_Name
      }
      if (this.ESRegion) {
        params['ESRegion'] = (this.ESRegion !== 'All Region') ? this.ESRegion : ''
      }
      if (this.selectedStatus) {
        params['Workload_Status'] = selectedStatus
      }
      if (this.from_date) {
        params['from_date'] = this.from_date
      }
      if (this.end_date) {
        params['to_date'] = this.end_date
      }
      if (this.selectedGlobalInitiative) {
        params['Global_Registered'] = 'Yes'
      }
      if (this.selectedGlacierInitiative) {
        params['Campaign_Name'] = 'Glacier'
      }
      if (this.selectedESRegion && this.selectedESRegion.length) {
        const excludeArray = ['All Region', 'All']
        params['ESRegion'] = this.selectedESRegion.filter(item => !excludeArray.includes(item)).toString()
      }
      if (this.AWS_ACE_ID) {
        params['AWS_ACE_ID'] = this.AWS_ACE_ID
      }
      if (this.RequestorEmail) {
        params.Requestor_Email = this.RequestorEmail
      }
      this.$store.dispatch('admin/oppregAdmin/getOppRegRequestData', params)
    },
    showChangelogs (workload) {
      this.$store.dispatch('showLogRecords', workload.Project_Id)
    },
    downloadAWSextracData () {
      let params = this.getReportFilters('download')
      this.$store.dispatch('admin/oppregAdmin/downloadOppRegRequestData', params)
    },
    extractAWSReportData () {
      let params = this.getReportFilters('report')
      this.$store.dispatch('admin/oppregAdmin/reportOppRegRequestData', params)
    },
    changedStatus (event) {
      console.log('selectedStatus', event)
      if (event.includes('All')) {
        this.selectedStatus = ['All']
      } else {
        this.selectedStatus = event;
      }
    },
    showNextData () {
      
      this.pagination.rowsPerPage = this.adminReportWorkloadList.length + this.pagination.rowsPerPage
      const selectedStatus = this.selectedStatus && !this.selectedStatus.includes('All') ? this.selectedStatus.toString() : '';

      let params = {
        nextPageKey: this.adminReportNextPageKey,
        size: this.pagination.size,
        orderBy: 'Date_Created',
        order: 'DESC'
      }
      if (this.sfdcId) {
        params['sfdcId'] = this.sfdcId
      }
      if (this.Customer_Name) {
        params['Customer_Name'] = this.Customer_Name
      }
      if (this.ESRegion) {
        params['ESRegion'] = (this.ESRegion !== 'All Region') ? this.ESRegion : ''
      }
      if (this.selectedStatus) {
        params['Workload_Status'] = selectedStatus
      }
      if (this.from_date) {
        params['from_date'] = this.from_date
      }
      if (this.end_date) {
        params['to_date'] = this.end_date
      }
      if (this.selectedESRegion && this.selectedESRegion.length) {
        const excludeArray = ['All Region', 'All']
        params['ESRegion'] = this.selectedESRegion.filter(item => !excludeArray.includes(item)).toString()
      }
      if (this.selectedESRegion && this.selectedESRegion.length) {
        const excludeArray = ['All Region', 'All']
        params['ESRegion'] = this.selectedESRegion.filter(item => !excludeArray.includes(item)).toString()
      }
      if (this.AWS_ACE_ID) {
        params['AWS_ACE_ID'] = this.AWS_ACE_ID
      }
      if (this.RequestorEmail) {
        params['Requestor_Email'] = this.RequestorEmail
      }
      this.$store.dispatch('admin/oppregAdmin/getOppRegRequestData', params)
    },
    onSelectESRegion (event) {
      if (event.includes('All Region')) {
        this.selectedESRegion = this.regions
      } else {
        this.selectedESRegion = event
      }
    },
    includesRegion (region) {
      const hasRegionFilter = this.$ability.rules.some(rule => rule.actions === 'report-filter-regions')
      if (hasRegionFilter) {
        if (!this.$ability.can('report-filter-regions', region)) {
          // console.log('includesRegion', region, hasRegionFilter, !this.$ability.can('report-filter-regions', region))
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    hasRegionFilter () {
      return this.$ability.rules.some(rule => rule.actions === 'report-filter-regions')
    },
  }
}
</script>

<style lang="scss" scoped>
.general-reporting {
  .v-input--selection-controls {
    margin-top: 7px;
  }
  .search-box {
    margin: 0 auto;
    padding-left: 10px;
    font-size: 5px;

    input {
      height: 15px;
    }
    label {
      font-size: 1rem;
      color: rgba(0,0,0,.87);
    }
  }

  .workload-detail-view {
    width: 80%;
    margin: 0 auto;

    table {
      width: 100%;
    }

    td, th {
      border: 1px solid #ddd;
      padding: 8px;
    }

    tr:nth-child(even){background-color: #f2f2f2;}

    tr:hover {background-color: #ddd;}

    th {
      padding-top: 12px;
      padding-bottom: 12px;
      text-align: left;
      background-color: #ffa726;
      color: #fff;
    }

  }
  .no-select {
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
  }
}
</style>
